import React = require('react');
import ApplePayButton from '../ApplePayButton';
import {IPaymentWalletProviderConfigData} from '../../../../data/api/models';
import * as api from '../../../../../app/data/api/api';

type ApplePayWrapperProps = {
  grossPremium: string;
  paymentWalletProviderConfigData: IPaymentWalletProviderConfigData;
  onPaymentAuthorized: (
    paymentData: ApplePayJS.ApplePayPayment,
  ) => Promise<any>;
  onClick?: () => void;
};

const ApplePayWrapper = ({
                           grossPremium,
                           paymentWalletProviderConfigData,
                           onPaymentAuthorized,
                           onClick: parentOnClick,
                         }: ApplePayWrapperProps) => {

  const onClick = () => {
    parentOnClick?.();

    const applePayRequest: ApplePayJS.ApplePayPaymentRequest = {
      countryCode: 'GB',
      currencyCode: 'GBP',
      merchantCapabilities: ['supports3DS'],
      supportedNetworks: ['visa', 'masterCard', 'amex'],
      total: {
        label: paymentWalletProviderConfigData.applePay.displayName,
        type: 'final',
        amount: grossPremium,
      }
    };

    const session = new ApplePaySession(3, applePayRequest);
    handleEventsForApplePay(session);
    session.begin();

    window.__APPLE_PAY_PAYMENT_SESSION__ = session;
  };

  function handleEventsForApplePay(session: ApplePaySession) {
    session.onvalidatemerchant = async (
      event: ApplePayJS.ApplePayValidateMerchantEvent
    ) => {
      api.getApplePaySession(event.validationURL)
        .then((merchantSession) => {
          session.completeMerchantValidation(merchantSession);
        })
        .catch(error => {
          console.error('Error during validating merchant', error);
        });
    };

    session.onpaymentauthorized = async (
      event: ApplePayJS.ApplePayPaymentAuthorizedEvent
    ) => {
      const paymentData = event.payment;

      if (!paymentData.token) {
        session.completePayment(ApplePaySession.STATUS_FAILURE);
        return;
      }

      onPaymentAuthorized(paymentData);
    };

    session.oncancel = async () => {
      window.__APPLE_PAY_PAYMENT_SESSION__ = undefined;
    };
  }

  return (
    <ApplePayButton
      onClick={onClick}
      className={'gateway-payment-button'}
      type="plain"
    />
  );
};

export default ApplePayWrapper;
